import { Component, Input, OnChanges } from '@angular/core'
import { MatSidenav } from '@angular/material/sidenav'
import { Router } from '@angular/router'
import { BRAND_PATH } from 'src/app/authentication/model/auth.enum'
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service'
import { MaterialModule } from 'src/app/shared/module/material.module'
import { ApiSearchUtilService } from 'src/app/shared/service/api-search-util/api-search-util.service'
import { StorageService } from 'src/app/shared/service/storage/storage.service'
import { environment } from 'src/environments/environment'
import { SubHeaderComponent } from './sub-header/sub-header.component'
import { CommonModule } from '@angular/common'
import { NotificationComponent } from '../notification/notification.component'
import { UserProfileComponent } from '../user-profile/user-profile.component'

const appVersion = environment.version
@Component({
    selector: 'ald-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        MaterialModule,
        SubHeaderComponent,
        CommonModule,
        NotificationComponent,
        UserProfileComponent,
        SubHeaderComponent
    ]
})
export class HeaderComponent implements OnChanges {
	constructor(
		private router: Router,
		private dialog: DialogService,
		public apiSearchUtilService: ApiSearchUtilService,
		private storage: StorageService
	) {}
	@Input() snav: MatSidenav
	@Input() isWelcome: boolean
	version: string
	image: any = {}
	basePath = window.location.hostname
	isOffline = false

	public BRAND_PATH = BRAND_PATH;

	ngOnChanges(): void {
		this.version = appVersion
		this.isOffline = this.storage.getSessionStorage('offline')
	}

	inOpenNotification(): void {
		this.router.navigate(['/alert'])
	}

	loadImage(): BRAND_PATH {
		const hostname = window.location.href
		switch (this.basePath) {
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				this.defineImgeObj(BRAND_PATH.FFM_FORD)
				return BRAND_PATH.FFM_FORD
			case this.apiSearchUtilService.findTerm(this.basePath, 'ford'):
				this.defineImgeObj(BRAND_PATH.FORD)
				return BRAND_PATH.FORD
			case this.apiSearchUtilService.findTerm(this.basePath, 'honda'):
				this.defineImgeObj(BRAND_PATH.HONDA)
				return BRAND_PATH.HONDA
			case this.apiSearchUtilService.findTerm(this.basePath, 'suzuki'):
				this.defineImgeObj(BRAND_PATH.SUZUKI)
				return BRAND_PATH.SUZUKI
			case this.apiSearchUtilService.findTerm(this.basePath, 'landrover'):
				this.defineImgeObj(BRAND_PATH.LAND_ROVER)
				return BRAND_PATH.LAND_ROVER
			case this.apiSearchUtilService.findTerm(this.basePath, 'jaguar'):
				this.defineImgeObj(BRAND_PATH.JAGUAR)
				return BRAND_PATH.JAGUAR
			case this.apiSearchUtilService.findTerm(this.basePath, 'lynkco'):
				this.defineImgeObj(BRAND_PATH.LYNKCO)
				return BRAND_PATH.LYNKCO
			case this.apiSearchUtilService.findTerm(this.basePath, 'smart'):
				this.defineImgeObj(BRAND_PATH.SMART)
				return BRAND_PATH.SMART
			case this.apiSearchUtilService.findTerm(this.basePath, 'omodajaecoo'):
				this.defineImgeObj(BRAND_PATH.OMODA_JAECOO)
				return BRAND_PATH.OMODA_JAECOO
			case this.apiSearchUtilService.findTerm(this.basePath, 'mg'):
				this.defineImgeObj(BRAND_PATH.MG)
				return BRAND_PATH.MG
			case this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement'):
				this.defineImgeObj(BRAND_PATH.FFM)
				return BRAND_PATH.FFM
			default:
				this.defineImgeObj(BRAND_PATH.MY_AYVENS)
				return BRAND_PATH.MY_AYVENS
		}
	}

	defineImgeObj(src): void {
		this.image.src = ''
		this.image.src = src
		let hostname = this.image.src.match(/[ \w-]+\./)
		hostname = hostname[0].replace(/\./g, '')
		this.image.styleName = hostname === 'myald' ? 'image-standard pointer' : 'image-brand pointer'
	}

	getClassForImageRender(): any {
		return this.image.styleName
	}

	backHome(): void {
		this.router.navigate(['/home'])
	}
}
